export default ({ nama = "", handleLogout = () => "" } = {}) => {
	const list =  [
		/**
		 * Generic
		 */
		{ id: "PENGUMUMAN", logo: "imp imp-pengumuman", menu: "Kelulusan", to: "/kelulusan" },

		{ id: "PROFIL", logo: "imp imp-profil", menu: nama },
		// { parent: "PROFIL", id: "PROFIL#ATUR#MURID", menu: "Pengaturan Profil", to: "/profil" },
		{ parent: "PROFIL", id: "PROFIL#KELUAR", menu: "Keluar / Log Out", onClick: handleLogout },
		//========================================================================
	];
	return list;
}